var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content-list-contents"},[_c('Breadcrumb',{attrs:{"links":_vm.links}}),_c('div',{staticClass:"content-list-contents-body"},[_c('div',{staticClass:"row"},_vm._l((8),function(n){return _c('div',{key:n,staticClass:"col-12 col-md-6 col-lg-3"},[_c('CardListContent')],1)}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }